module.exports = __webpack_public_path__ + "img/greenReadingArt2.04abbb01.png";